import { useEffect } from 'react'
import { observer } from 'mobx-react'

import useStore from '@/hooks/useStore'

function PlaneDistance() {
  const measureStore = useStore('measureStore')

  useEffect(() => {
    init()
    return () => {
      measureStore.destroy()
    }
  }, [])

  const init = () => {
    const obj = {
      cesiumview: window.cviewer,
      callback: () => {
        measureStore.setIsClosedMeasure(true)
      },
    }
    measureStore.planeDistance(obj)
  }
  return <div></div>
}
export default observer(PlaneDistance)
